// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — buttons.styled.classic.js, новая — buttons.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './buttons.styled.classic';
import * as cp from './buttons.styled.cp';

export const Button = isCp ? cp.Button : classic.Button;
export const ButtonCall = isCp ? cp.ButtonCall : classic.ButtonCall;
export const ButtonDrop = isCp ? cp.ButtonDrop : classic.ButtonDrop;
